export enum NewOldType {
  "Ｎｏｗ",
  "古いかも？",
  "古いです",
}
